/**
 * Popow 연락처 정보 상수
 */

/** 공식 지원/문의용 이메일 */
export const SUPPORT_EMAIL = 'help@popow.ai';

/** 공지/어나운스용 이메일 */
export const ANNOUNCE_EMAIL = 'hello@popow.ai';

/** mailto 링크 생성 헬퍼 */
export const createMailtoLink = (subject?: string, body?: string): string => {
  const params = new URLSearchParams();
  if (subject) {
    params.set('subject', subject);
  }
  if (body) {
    params.set('body', body);
  }

  const queryString = params.toString();
  return `mailto:${SUPPORT_EMAIL}${queryString ? `?${queryString}` : ''}`;
};
